import { ConductedStressAssessmentEmpty } from './ConductedStressAssessmentEmpty';
import { ConductedStressAssessmentList } from './ConductedStressAssessmentList';
import styles from './styles.module.scss';

type ConductedStressAssessmentListProps = React.ComponentProps<
  typeof ConductedStressAssessmentList
>;

type Props = {
  conductedStressAssessments: ConductedStressAssessmentListProps['conductedStressAssessments'];
  onRowClick: ConductedStressAssessmentListProps['onRowClick'];
  pagerProps: ConductedStressAssessmentListProps['pagerProps'];
};

export const StressAssessmentListPresentation: React.FC<Props> = ({
  conductedStressAssessments,
  onRowClick,
  pagerProps,
}) => {
  return (
    <div>
      <main className={styles.body}>
        {conductedStressAssessments.length > 0 ? (
          <ConductedStressAssessmentList
            conductedStressAssessments={conductedStressAssessments}
            onRowClick={onRowClick}
            pagerProps={pagerProps}
          />
        ) : (
          <ConductedStressAssessmentEmpty />
        )}
      </main>
    </div>
  );
};
